import React from 'react';
import Toolbar from 'react-big-calendar/lib/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import RightArrowIcon from '@material-ui/icons/ChevronRight';
import LeftArrowIcon from '@material-ui/icons/ChevronLeft';
import Map from '@material-ui/icons/Map';
import Framework from "@beardeddevops/react.framework";
import moment from 'moment'
import {Button, Modal, ModalBody, ModalHeader} from "reactstrap";


export default class CalendarToolbar extends Toolbar {

	constructor(props) {
		super(props);
		this.state = {
			showDate: false,
			selectedDay: Date.now(),
			viewSent: false,
		}
	}

	componentDidMount() {
		const view = this.props.view;
	}

	componentDidUpdate(prevState, prevProps, snapshot)
	{
		this.state.viewSent = false;
		if (!this.state.viewSent)
		{
			this.props.handleView(this.props.view)
			this.state.viewSent = true;
		}
	}

	showDatePicker = () => {
		this.setState({showDate: true})
	}

	toggleClose = () => {
		this.setState({showDate: false})
	}

	handleDateChange = (name, date) => {
		this.setState({selectedDay: new Date(date)})
		this.props.onNavigate('DATE', new Date(date))
		this.toggleClose();
	}

	launchDailyMap = () => {
		window.open(this.props.dailyLink, '_blank')
	}


	render() {
		// console.log(this.props.dailyLink)
		return (
			<div>
				<Modal
					isOpen={this.state.showDate}
					toggle={this.toggleClose}
					size={"sm"}
					backdrop={true}
				>
					<ModalHeader toggle={this.toggleClose}>
						{"Set Custom Date"}
					</ModalHeader>
					<ModalBody>
						<Framework.Elements.Date
							label={"Custom Date"}
							value={this.state.selectedDate}
							update={this.handleDateChange}
						/>
					</ModalBody>
				</Modal>
				<div className={"row rbc-toolbar"}>
					<div className={"rbc-btn-group"}>
						<IconButton onClick={() => this.navigate('PREV')}><LeftArrowIcon/></IconButton>
						<button className="rbc-today" type="button" onClick={() => this.navigate('TODAY')}>Today</button>
						<IconButton onClick={() => this.navigate('NEXT')}><RightArrowIcon/></IconButton>
					</div>
					<div className={"rbc-toolbar-label"}>
						<label onClick={this.showDatePicker}>
							{this.props.label}
						</label>
						{this.props.dailyLink !== 'https://www.google.com/maps/dir' &&
							<IconButton style={{marginLeft: 10}} onClick={this.launchDailyMap}><Map/></IconButton>}
					</div>
					<div className={"rbc-btn-group"}>
						{/*This doesnt keep "clicked" that's probably okay*/}
						<button type="button" onClick={this.view.bind(null, 'day')}>Day</button>
						<button type="button" onClick={this.view.bind(null, 'week')}>Week</button>
					</div>
				</div>
			</div>

		);
	}
}
